import { useState, useEffect } from 'react';
import api from 'state/axios';
import { 
    useTheme, 
    Box, 
    Typography, 
    CircularProgress,  
    Accordion, 
    AccordionSummary, 
    AccordionDetails,  
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import useAuthCheck from 'hooks/useAuthCheck';
import { LAYOUT_HEIGHT } from 'state/constants';
import Header from 'components/Header';
import FlexBetween from 'components/FlexBetween';
import FlexCenter from 'components/FlexCenter';


const FAQViewer = () => {
    useAuthCheck();
    const theme = useTheme();
    const greenDeep = theme.palette.green.deep;

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);  
    
    const [faqs, setFaqs] = useState([]);

    
    
    useEffect(() => {
        const handleFaqs = async () => {
            try {
                setError(null);
                setLoading(true);
            
                const res = await api.get('/faqs');        
                setFaqs(res.data);
            } catch (error) {
                setError(error);
            } finally {
                setLoading(false);
            }
        };
        
        handleFaqs();
    }, []); 
    

    return (
        <Box className="main-container-box">
            <FlexBetween>
                <Header 
                    title="FAQ" 
                    subtitle={`${loading ? 'Loading...' : 'Frequently Asked Questions'}`}
                />       
            </FlexBetween>  
            {loading ? (
                <FlexCenter height={LAYOUT_HEIGHT}>
                    <CircularProgress />
                </FlexCenter>
            ) : error ? (
                <FlexCenter height={LAYOUT_HEIGHT}>
                    <Typography color="error">Error: {error.message}</Typography>
                </FlexCenter>
            ) : (
                <Box>   
                    {faqs && faqs.map((faq, index) => (
                        <Accordion key={index} defaultExpanded sx={{ marginBottom: '8px' }}>
                            <AccordionSummary expandIcon={<ExpandMore />}>
                                <Typography color={greenDeep} variant="h5">
                                    {faq.title}
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography>
                                    {faq.content}
                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                    ))}                         
                </Box>
            )}
        </Box>
    );
};

export default FAQViewer;
